export default {"src":"/_next/static/media/SubDesc2.803061e4.svg","height":201,"width":200,"blurWidth":0,"blurHeight":0};